'use client';

import { LottieAnimation } from '@/shared/components/ui/LottieAnimation';
import { GTM_EVENT } from '@/shared/constants/gtm';
import { GENTOO_CUSTOM_BUTTON_ID } from '@/shared/lib/gentoo';
import { gtmClick } from '@/shared/utils/gtm';

const ZENTO_LOTTIE_SRC = '/lottie/gentoo-btn.json';

/**
 * 시안 effect `test_gra3` 의 3중 그림자 — 디자인 시스템 shadow 토큰에 대응 값이 없어 직접 지정한다.
 * blur 는 Figma 값을 그대로 쓴다 (MCP 가 내려주는 filter drop-shadow 표기는 blur 가 절반이라 그대로 옮기면 안 된다).
 * MO 는 PC 값의 0.7배 (버튼 크기 비율 56/80 과 동일).
 */
const SHADOW_MO =
  'shadow-[0px_3.5px_7px_rgba(0,0,0,0.05),0px_1.4px_4.9px_rgba(0,0,0,0.05),0px_0px_2.8px_rgba(0,0,0,0.08)]';
const SHADOW_PC =
  'desktop:shadow-[0px_5px_10px_rgba(0,0,0,0.05),0px_2px_7px_rgba(0,0,0,0.05),0px_0px_4px_rgba(0,0,0,0.08)]';

/**
 * 프로젝트 기본 젠투 트리거. SDK 는 `isCustomButton: true` 로 init 되어
 * `#gentoo-custom-button` 을 가진 엘리먼트의 클릭을 잡아 채팅창을 연다.
 * (SDK 로드/부팅은 `GentooInitializer` 에서 담당)
 *
 * 오렌지 배경은 버튼이 그리고, Lottie 는 그 위에 얹히는 전경 레이어다
 * (Lottie 캔버스 80×80 = PC 버튼 박스와 동일해 시안 위치가 그대로 재현된다).
 */
export function ZentoButton() {
  return (
    <button
      id={GENTOO_CUSTOM_BUTTON_ID}
      type="button"
      aria-label="실시간 채팅 상담"
      // SDK 모바일 번들(floating-modal.js)은 커스텀 버튼을 class 로만 찾는다
      // (`getElementsByClassName('gentoo-custom-button')[0]`). id 만으론 못 잡는다.
      className={`${GENTOO_CUSTOM_BUTTON_ID} rounded-16 desktop:rounded-24 desktop:size-80 bg-primary-600 hover:bg-primary-700 relative block size-56 transition-colors ${SHADOW_MO} ${SHADOW_PC}`}
      {...gtmClick(GTM_EVENT.FLOATING, '젠투')}
    >
      <LottieAnimation
        src={ZENTO_LOTTIE_SRC}
        className="pointer-events-none absolute inset-0"
      />
    </button>
  );
}
